module.exports = __webpack_public_path__ + "svg/icon-ul-li.svg";